exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".hide___1SigY {\n  display: none;\n}\n.donation-terms-container___3ZOHV {\n  text-align: left;\n}\n.donation-form-container___COL2t {\n  text-align: left;\n}\n", "", {"version":3,"sources":["/causefundraisernodeweb-ci-1233/workspace/causefundraisernodeweb-ci-1233/public/js/components/charity.less"],"names":[],"mappings":"AAAA;EACE,cAAc;CACf;AACD;EACE,iBAAiB;CAClB;AACD;EACE,iBAAiB;CAClB","file":"charity.less","sourcesContent":[".hide {\n  display: none;\n}\n.donation-terms-container {\n  text-align: left;\n}\n.donation-form-container {\n  text-align: left;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"hide": "hide___1SigY",
	"donation-terms-container": "donation-terms-container___3ZOHV",
	"donation-form-container": "donation-form-container___COL2t"
};